export const MIN_OVERAGE_WIRE_COUNT = 1;
export const MAX_OVERAGE_WIRE_COUNT = 20;
